// extracted by mini-css-extract-plugin
export default {"leaderboard":"R2C1F2","sectionTitle":"_1BhKsw"};